import type { WebDeploymentConfig } from "./deployment-profile.js";

/** Exact public endpoint set injected by vite.config.ts for this artifact. */
export const WEB_DEPLOYMENT_CONFIG: WebDeploymentConfig =
  __KLASS_SHARE_WEB_DEPLOYMENT_CONFIG__;

export const WEB_ROOM_DIRECTORY_ENABLED: boolean =
  __KLASS_SHARE_WEB_ROOM_DIRECTORY_ENABLED__;
